import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const editCampaignNotification = async (domain: string, campaignId: number, templateId: number, notificationData: any): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `campaigns/${campaignId}/message/${templateId}`,
        method: 'PUT',
        params: notificationData,
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}